import { observer } from "mobx-react";
import { useEffect } from "react";
import { Navigate, useLocation, useOutlet } from "react-router-dom";
import styled from "styled-components";
import { userStore } from "../modules/stores";
import { onboardingController } from "../modules/controllers";
import { OnboardingModal } from "./Onboarding";
import Navbar from "./Navbar";

const Wrapper = styled.div`
  padding: 40px 15px 0 15px;
  color: #000;
  min-height: 100vh;
`;

export const ProtectedLayout = observer(() => {
  const outlet = useOutlet();
  const location = useLocation();

  useEffect(() => {
    if (userStore.isLoggedIn) {
      onboardingController.startIfNeeded();
    }
  }, []);

  useEffect(() => {
    const handlePopupCallback = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === "mychart-auth" && typeof event.data.search === "string") {
        onboardingController.handleMyChartCallback(
          new URLSearchParams(event.data.search)
        );
      }
    };
    window.addEventListener("message", handlePopupCallback);
    return () => window.removeEventListener("message", handlePopupCallback);
  }, []);

  useEffect(() => {
    // If we're in the popup window, relay the callback back to the opener and close.
    if (
      window.opener &&
      window.opener !== window &&
      new URLSearchParams(location.search).get("flow") === "onboarding"
    ) {
      try {
        window.opener.postMessage(
          { type: "mychart-auth", search: window.location.search },
          window.location.origin
        );
      } catch (err) {
        // ignore cross-window errors
      }
      window.close();
      return;
    }

    if (userStore.isLoggedIn) {
      onboardingController.handleMyChartCallback(
        new URLSearchParams(location.search)
      );
    }
  }, [location.search]);

  if (!userStore.isLoggedIn) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <Navbar />
      <OnboardingModal controller={onboardingController} />
      <Wrapper>{outlet}</Wrapper>
    </div>
  );
});
